// extracted by mini-css-extract-plugin
export default {"details":"Collapse__details--tqYOZ","content":"Collapse__content--KsQji","icon":"Collapse__icon--z5KO1"};